Vue.component('game-detail', {
  props: {
    series: {
      type: Object,
      required: true,
    },
    game: {
      type: Object,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
  },
  template: `
<div class="game-detail">
  <div class="is-flex is-justify-content-center is-flex-wrap-wrap">
    <div class="mx-2">
      <template v-if="game.hideDate">
        <template v-if="game.published">-</template>
        <template v-else="v-else">（開催日時未定）</template>
      </template>
      <template v-else="v-else">{{ game.actualDate ? dateFormat(game.actualDate) : dateFormat(game.date) }} キックオフ</template>
    </div>
    <div class="mx-2">
      <div class="icon-text"><span class="icon map-marker"><i class="fas fa-map-marker-alt"></i></span><span>{{ game.hideVenue ? '非公開' : (game.venue || '（未定）') }}</span></div>
    </div>
  </div>
  <div class="game-result-table">
    <div>
      <div class="is-flex is-align-items-flex-end">
        <template v-if="isGameOver">
          <template v-if="isJustification">
            <div class="score is-justify-content-center">-</div>
          </template>
          <template v-else="v-else">
            <div style="margin:0 auto;padding-bottom:3px;">不成立</div>
          </template>
        </template>
        <template v-else="v-else">
          <div style="margin:0 auto;">VS</div>
        </template>
      </div>
      <div class="team-name-score" v-for="(record, i) in records" :key="i">
        <div>
          <div class="score" v-if="isGameOver &amp; isJustification">
            <template v-if="isTournamentWithoutPlay">{{ record.manualGoals * 1 ? '○': '×' }}</template>
            <template v-else="v-else">{{ record.score }}</template>
          </div>
          <div class="team-name">{{ record.team.display || '（未定）' }}</div>
        </div>
      </div>
    </div>
    <!-- PK-->
    <div class="pk-score" v-if="isPk">
      <div class="is-justify-content-center">PK</div>
      <div class="is-size-5" v-for="(record, i) in records" :key="i">{{ record.pk }}</div>
    </div>
    <template v-if="comment">
      <div class="notification mb-0 px-3" v-html="comment"></div>
    </template>
    <template v-if="isGameOver &amp; isJustification">
      <div>
        <div>〔得点〕</div>
        <div v-for="(record, i) in records" :key="i">
          <div class="mb-2" v-for="(goal, j) in goals(record)" :key="i + '-' + j">
            <div class="icon"><i class="fas fa-futbol"></i></div>
            <div class="time">{{ goal.time }}分</div>
            <div class="player">{{ playerName(goal.playerId) }}</div>
          </div>
        </div>
      </div>
      <div>
        <div>〔警告〕</div>
        <div v-for="(record, i) in records" :key="i">
          <div class="mb-2" v-for="(card, j) in yellowCards(record)" :key="i + '-' + j"><span class="tag yellow-card mx-1">{{ card.card }}</span>
            <div class="time">{{ card.time | time }}</div>
            <div class="player mx-1">{{ playerName(card.playerId) }}</div>
          </div>
        </div>
      </div>
      <div class="p-4">
        <div>〔退場〕</div>
        <div v-for="(record, i) in records" :key="i">
          <div class="mb-2" v-for="(card, j) in redCards(record)" :key="i + '-' + j"><span class="tag red-card mx-1">{{ card.card }}</span>
            <div class="time">{{ card.time | time }}</div>
            <div class="player mx-1">{{ playerName(card.playerId) }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
  <template v-if="isGameOver &amp; isJustification">
    <div class="py-4" style="border-top:1px solid #eee;">
      <div class="field is-grouped is-grouped-multiline">
        <div class="control" v-for="card in cardTypes.yellow" :key="card[0]">
          <div class="tags has-addons"><span class="tag yellow-card">{{ card[0] }}</span><span class="tag">{{ card[1] }}</span></div>
        </div>
        <div class="control" v-for="card in cardTypes.red" :key="card[0]">
          <div class="tags has-addons"><span class="tag red-card">{{ card[0] }}</span><span class="tag">{{ card[1] }}</span></div>
        </div>
      </div>
    </div>
    <template v-if="dataVersion &gt; 1">
      <div class="has-text-centered mt-5 pt-3" style="border-top:1px solid #ccc;">〔メンバー〕</div>
      <div class="team-order-table mt-4">
        <div>
          <div class="is-size-7" v-for="i in 2" :key="i">
            <div>Pos</div>
            <div>選手</div>
            <div class="is-flex">
              <div>交代</div>
              <div class="ml-auto">シュート</div>
            </div>
          </div>
        </div>
        <div v-for="i in startersCount" :key="i">
          <div v-for="j in 2" :key="i + '-' + j">
            <template v-if="!!starters[j - 1][i - 1]">
              <div>{{ starters[j - 1][i - 1].position }}</div>
              <div><span>{{ starters[j - 1][i - 1].number }}</span>{{ starters[j - 1][i - 1].name }}</div>
              <div class="is-flex">
                <div><span class="change" v-for="(sub, k) in starters[j - 1][i - 1].subs" :key="i + '-' + j + '-' + k"><span class="has-text-danger">{{ sub.type }}</span><span>{{ sub.time }}</span></span></div>
                <div class="ml-auto"><span class="shoot">{{ starters[j - 1][i - 1].shoots.first }}</span><span class="shoot">{{ starters[j - 1][i - 1].shoots.second }}</span><span class="shoot" v-if="isExtra">{{ starters[j - 1][i - 1].shoots.third }}</span></div>
              </div>
            </template>
            <template v-else="v-else">&nbsp;</template>
          </div>
        </div>
      </div>
      <div class="team-order-table mt-5">
        <div v-for="i in benchesCount" :key="i">
          <div v-for="j in 2" :key="i + '-' + j">
            <template v-if="!!benches[j - 1][i - 1]">
              <div>{{ benches[j - 1][i - 1].position }}</div>
              <div><span>{{ benches[j - 1][i - 1].number }}</span>{{ benches[j - 1][i - 1].name }}</div>
              <div class="is-flex">
                <div><span class="change" v-for="(sub, k) in benches[j - 1][i - 1].subs" :key="i + '-' + j + '-' + k"><span class="has-text-danger">{{ sub.type }}</span><span>{{ sub.time }}</span></span></div>
                <div class="ml-auto"><span class="shoot">{{ benches[j - 1][i - 1].shoots.first }}</span><span class="shoot">{{ benches[j - 1][i - 1].shoots.second }}</span><span class="shoot" v-if="isExtra">{{ benches[j - 1][i - 1].shoots.third }}</span></div>
              </div>
            </template>
            <template v-else="v-else">&nbsp;</template>
          </div>
        </div>
      </div>
      <div class="team-order-table mt-5">
        <div>
          <div v-for="(shoots, i) in shootSums" :key="i"><span class="mr-auto">シュート</span><span class="shoot-sums"><span class="pr-4">前半: {{ shoots.first }}</span><span class="pr-4">後半: {{ shoots.second }}</span><span class="pr-4" v-if="isExtra">延長: {{ shoots.third }}</span><span>合計: {{ shoots.first + shoots.second + shoots.third + shoots.fourth }}</span></span></div>
        </div>
      </div>
      <div class="team-order-table mt-5">
        <div>
          <div v-for="(record, i) in records" :key="i">
            <div>{{ record.mcm ? record.mcm.post || '' : '' }}</div>
            <div>{{ record.mcm ? record.mcm.name || '' : '' }}</div>
          </div>
        </div>
      </div>
      <div class="mt-4" v-if="game.referees">
        <div class="columns">
          <div class="column">
            <div class="is-size-7">主審</div>{{ game.referees[0] }}
          </div>
          <div class="column">
            <div class="is-size-7">副審</div>{{ game.referees[1] }}<br/>{{ game.referees[2] }}
          </div>
          <div class="column">
            <div class="is-size-7">第4の審判員</div>{{ game.referees[3] }}
          </div>
        </div>
      </div>
    </template>
  </template>
</div>`,
  data() {
    return {
      cardTypes: CARD_TYPES,
    }
  },
  filters: {
    time(val) {
      return /^[\d+]+$/.test(val) ? `${val}分` : val
    },
  },
  computed: {
    isExtra() {
      return _.get(this.game, 'extraTime', '0') > 0
    },
    records() {
      return this.game.gameRecords || []
    },
    isGameOver() {
      return this.game.gameOver
    },
    isJustification() {
      return !this.game.noJustification
    },
    isTournamentWithoutPlay() {
      return (this.series.type === 'tournament') && (parseInt(_.get(this.records, '0.manualGoals', 0)) + parseInt(_.get(this.records, '1.manualGoals', 0)) > 0)
    },
    isPk() {
      return parseInt(_.get(this.records, '0.pk', 0)) + parseInt(_.get(this.records, '1.pk', 0)) > 0
    },
    comment() {
      const comment = (this.game.comment || '').trim()
      if (!comment) {
        return false
      }
      return comment.replace(/\n/, '<br>')
    },
    substitutions() {
      return this.records.map((rec) => {
        return (rec.substitutions || []).map((data, idx) => {
          return { idx, ...data.value }
        })
      })
    },
    shootSums() {
      return this.records.map((rec) => {
        return (rec.shoots || []).reduce((sums, shoot) => {
          const { value } = shoot
          sums.first += parseInt(value.first)
          sums.second += parseInt(value.second)
          sums.third += parseInt(value.third)
          sums.fourth += parseInt(value.fourth)
          return sums
        }, { first: 0, second: 0, third: 0, fourth: 0 })
      })
    },
    shoots() {
      return this.records.reduce((obj, rec) => {
        const shoots = (rec.shoots || []).reduce((obj, shoot) => {
          const { value } = shoot
          return { ...obj, [value.playerId]: value }
        }, {})
        return { ...obj, ...shoots }
      }, {})
    },
    starters() {
      return this.records.map((data, i) => {
        return (data.starters || []).map((player) => {
          const { value } = player
          const subs = [
            ...(_.filter(this.substitutions[i], { inPlayerId: value.playerId }).map((data) => {
              return { type: '▲', ...data }
            })),
            ...(_.filter(this.substitutions[i], { outPlayerId: value.playerId }).map((data) => {
              return { type: '▼', ...data }
            })),
          ]
          subs.sort((a, b) => {
            return a - b
          })
          const shoots = this.shoots[value.playerId] || { first: 0, second: 0, third: 0 }
          return { ...value, subs, shoots }
        })
      })
    },
    startersCount() {
      return Math.max(this.starters[0].length, this.starters[1].length)
    },
    benches() {
      return this.records.map((data, i) => {
        return (data.benches || []).map((player) => {
          const { value } = player
          const subs = [
            ...(_.filter(this.substitutions[i], { inPlayerId: value.playerId }).map((data) => {
              return { type: '▲', ...data }
            })),
            ...(_.filter(this.substitutions[i], { outPlayerId: value.playerId }).map((data) => {
              return { type: '▼', ...data }
            })),
          ]
          subs.sort((a, b) => {
            return a - b
          })
          const shoots = this.shoots[value.playerId] || { first: 0, second: 0, third: 0 }
          return { ...value, subs, shoots }
        })
      })
    },
    benchesCount() {
      return Math.max(this.benches[0].length, this.benches[1].length)
    },
    // 試合データのバージョン
    dataVersion() {
      if (this.startersCount === 0 && this.benchesCount === 0) {
        return 1
      }
      return 2
    },
  },
  methods: {
    dateFormat(date) {
      return dayjs(date).format('YYYY/MM/DD(dd) HH:mm')
    },
    goals(data) {
      return data.records.reduce((records, item) => {
        if (item.value.type === 'goal') {
          records.push(item.value)
        }
        return records
      }, [])
    },
    yellowCards(data) {
      return data.records.reduce((records, item) => {
        if (item.value.type === 'card' && item.value.card.startsWith('C')) {
          records.push(item.value)
        }
        return records
      }, [])
    },
    redCards(data) {
      const yellows = {}
      return data.records.reduce((records, item) => {
        if (item.value.type === 'card') {
          if (item.value.card.startsWith('C')) {
            // yellow card
            yellows[item.value.playerId] = (yellows[item.value.playerId] ? yellows[item.value.playerId] : 0) + 1
            if (yellows[item.value.playerId] > 1) {
              // CS
              records.push({
                ...item.value,
                card: 'CS'
              })
            }
          } else if  (item.value.card.startsWith('S')) {
            // red card
            records.push(item.value)
          }
        }
        return records
      }, [])
    },
    playerName(id) {
      const player = this.players.find((item) => {
        return item.playerId === id
      })
      return _.get(player, 'name', '---')
    },
    cardColor(card) {
      const cardColors = {
        C1: 'yellow',
        C2: 'yellow',
        C3: 'yellow',
        C4: 'yellow',
        C5: 'yellow',
        C6: 'yellow',
        C7: 'yellow',
        C8: 'yellow',
        S1: 'red',
        S2: 'red',
        S3: 'red',
        S4: 'red',
        S5: 'red',
        S6: 'red',
        CS: 'red',
      }
      return _.get(cardColors, card.card, '')
    },
  },
})
